/**
 * Collection Facets (Filtering)
 * Handles product filtering functionality
 */

class FacetFilters extends HTMLFormElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    
    this.renderPage(searchParams);
  }

  renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newResults = html.querySelector('.collection-grid__products');
        
        if (newResults) {
          document.querySelector('.collection-grid__products').innerHTML = newResults.innerHTML;
        }

        // Update URL without reload
        window.history.pushState({ searchParams }, '', url);
      })
      .catch(error => {
        console.error('Error filtering products:', error);
      });
  }
}

if (typeof customElements.get('facet-filters') === 'undefined') {
  customElements.define('facet-filters', FacetFilters, { extends: 'form' });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
